<script>
import rubricItemsJSON from '@/assets/courseReview/rubric_items.json'

  export default {
    name: 'CombinedRubricItem',
    data() {
      return {
        comment: null
      }
    },
    computed: {
      reviewInfo() {
        return this.$store.getters.reviewInfo
      },
      isDeveloper() {
        if (this.reviewInfo.reviewer_role === 'Developer') {
          return true
        } else {
          return false
        }
      },
      rubricItem() {
        return rubricItemsJSON.find(item => item.id === this.rubricId)
      },
      rubricItemComments() {
        if (this.reviewInfo.comments){
        return this.reviewInfo.comments.filter(comment => comment.item_id === this.rubricId)
        } else {
          return null
        }
      },
      rubricItemNonHiddenComments() {
        if (this.reviewInfo.comments) {
        return this.rubricItemComments.filter(comment => !comment.is_hidden)
        } else {
          return null
        }
      },
      // TODO: send ratings unwrapped from API
      ofditRating() {
      if (this.reviewInfo.ofdit_ratings) {
        const result = this.reviewInfo.ofdit_ratings[0][`rating_${this.rubricId}`]
        if (result) {
          return result
        } else {
          return 'Not submitted'
        }
      } else {
        return 'Not submitted'
      }
      },
      peerRating() {
      if (this.reviewInfo.peer_ratings) {
        const result = this.reviewInfo.peer_ratings[0][`rating_${this.rubricId}`]
        if (result) {
          return result
        } else {
          return 'Not submitted'
        }
      } else {
        return 'Not submitted'
      }
      }
    },
    methods: {
      editComment(comment) {
          this.$store.commit('cr_setEditComment', comment)
          this.$bvModal.show('edit-modal')
        },
      async hideComment(id){
        try {
          await this.$store.dispatch('cr_callAPI', {
            url: `/r/comments/${this.reviewInfo.id}/${id}/status`,
            method: 'put',
            data: { status: 'hide' }
              })
        } catch(err) {
          this.$root.$bvToast.toast(
            `Error updating status of comment ${id}. If the problem persists, please contact the OFDIT lead.
      ${err.message}.`,
            {
              title: 'Error',
              toaster: 'b-toaster-top-center',
              variant: 'danger'
            }
          )
        } finally {
          const comments = await this.$store.dispatch('cr_callAPI', {
            url: `/r/reviews/${this.reviewInfo.id}/comments`
          })
          this.$store.commit('cr_updateComments', comments)
        }
      },
      async addressComment(id){
        try {
          await this.$store.dispatch('cr_callAPI', {
            url: `/r/comments/${this.reviewInfo.id}/${id}/status`,
            method: 'put',
            data: { status: 'addressed' }
              })
        } catch(err) {
          this.$root.$bvToast.toast(
            `Error updating status of comment ${id}. If the problem persists, please contact the OFDIT lead.
      ${err.message}.`,
            {
              title: 'Error',
              toaster: 'b-toaster-top-center',
              variant: 'danger'
            }
          )
        } finally {
          const comments = await this.$store.dispatch('cr_callAPI', {
            url: `/r/reviews/${this.reviewInfo.id}/comments`
          })
          this.$store.commit('cr_updateComments', comments)
        }
      },
      async submitComment() {
        try {
          if (!this.comment) {
            throw Error ('You cannot create an empty comment')
          }
          const comments = [{
            item_id: this.rubricId,
            content: this.comment.trim(),
          }]
          await this.$store.dispatch('cr_callAPI', {
            url: `/r/comments/${this.reviewInfo.id}`,
            method: 'post',
            data: {comments,}
              })
          this.$root.$bvToast.toast(
      `You have successfully entered a comment.`,
            {
              title: 'Success',
              autoHideDelay: 1000,
              toaster: 'b-toaster-top-center',
              variant: 'success'
            }
          )
          this.comment = null
        } catch (err) {
          this.$root.$bvToast.toast(
            `Error creating comment. If the problem persists, please contact the OFDIT lead.
      ${err.message}.`,
            {
              title: 'Error',
              toaster: 'b-toaster-top-center',
              variant: 'danger'
            }
          )
        } finally {
          const comments = await this.$store.dispatch('cr_callAPI', {
            url: `/r/reviews/${this.reviewInfo.id}/comments`
          })
          this.$store.commit('cr_updateComments', comments)
        }
      }
    },
    props: {
      rubricId: Number,
    }
  }
</script>

<template>
  <div>
    <b-table-simple>
            <col style="width: 60%" />
            <col style="width: 20%" />
            <col style="width: 20%" />
      <b-thead>
        <b-tr v-if="rubricId !== 100">
          <b-th>Item</b-th>
          <b-th>OFDIT rating</b-th>
          <b-th>Peer rating</b-th>
        </b-tr>
        <b-tr v-else>
          <b-th>Item</b-th>
          <b-th></b-th>
          <b-th></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr :class="{ 'bg-yellow-sps': (ofditRating === 'Needs work' || peerRating === 'Needs work') }"
        >
          <b-td>
            <b-icon icon="clipboard-check"/> {{ rubricItem.text }}
          </b-td>
          <b-td v-if="rubricId !== 100">{{ ofditRating }}</b-td>
          <b-td v-if="rubricId !== 100">{{ peerRating }}</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <div v-if="!isDeveloper">
      <b-table-simple v-if="rubricItemComments && rubricItemComments.length > 0">
            <col style="width: 15%" />
            <col style="width: 15%" />
            <col style="width: 50%" />
            <col style="width: 30%" />
      <b-thead>
        <b-tr>
          <b-th>Author</b-th>
          <b-th>Date</b-th>
          <b-th>Comment</b-th>
          <b-th></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="item in rubricItemComments" :key="item.id" :class="{ hide: item.is_hidden}">
          <b-td>{{ item.author }}</b-td>
          <b-td>{{ item.date }}</b-td>
          <b-td>{{ item.content }}<p v-if="item.is_addressed">☝<em>The developer says they have addressed this.</em></p></b-td>
          <b-td>
            <b-button class="mr-2" v-if="!item.is_hidden" @click="hideComment(item.id)" variant="outline-success" size="sm">Hide</b-button>
            <b-button v-if="item.author === reviewInfo.reviewer_role" @click="editComment(item)" variant="outline-warning" size="sm">Edit</b-button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
    <div v-if="isDeveloper">
      <b-table-simple v-if="rubricItemNonHiddenComments && rubricItemNonHiddenComments.length > 0">
            <col style="width: 15%" />
            <col style="width: 15%" />
            <col style="width: 70%" />
            <col style="width: 10%" />
      <b-thead>
        <b-tr>
          <b-th>Author</b-th>
          <b-th>Date</b-th>
          <b-th>Comment</b-th>
          <b-th></b-th>
        </b-tr>
      </b-thead>

      <b-tbody>
        <b-tr v-for="item in rubricItemNonHiddenComments" :key="item.id" :class="{ addressed: item.is_addressed}">
          <b-td>{{ item.author }}</b-td>
          <b-td>{{ item.date }}</b-td>
          <b-td>{{ item.content }}</b-td>
          <b-td><b-button class="mr-2" v-if="!item.is_addressed" @click="addressComment(item.id)" variant="outline-success" size="sm">Resolve</b-button>
            <b-button v-if="item.author === reviewInfo.reviewer_role" @click="editComment(item)" variant="outline-warning" size="sm">Edit</b-button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
        <b-form-group
          label="Enter a comment"
          :label-for="`rubric-comment-${rubricId}`"
          class="w-75"
        >
          <b-form-textarea
            :id="`rubric-comment-${rubricId}`"
            name="comment"
            v-model="comment"
            rows="4"
          ></b-form-textarea>
        </b-form-group>
    <b-button
      class="my-2"
      variant="success"
      size="sm"
      @click="submitComment"
      >Submit comment</b-button
    >
    <hr />
  </div>
</template>

<style>
.hide {
  text-decoration: line-through;
  color: #6c757d;
}

.addressed {
  color: #6c757d;
}

.bg-yellow-sps {
  background-color : #ffffe0;
}
</style>
